// extracted by mini-css-extract-plugin
export default {"disclosureHeader":"Disclosure_disclosureHeader__R3vOb","disclosureContent":"Disclosure_disclosureContent__gm5us","expanded":"Disclosure_expanded__3qeTm"};